export const TOTAL_CARD_POINTS = 100;
export const GRID_LENGTH = 16;
export const MIN_GROUP_CARDS = 3;
export const MIN_DECK_GROUPS = 2;

export const CARD_TYPE = {
    CardText: "card-text",
    CardAudio: "card-audio",
    CardImage: "card-image",
    CardTextAudio: "card-text-audio",
    CardTextImage: "card-text-image"
}

export const RELACIONAR_SOUNDS = {
    COLLECT: 'relacionar-collect',
    SELECT_GROUP: 'relacionar-selectGroup',
    DESELECT: 'relacionar-deselect',
    LOAD: 'relacionar-load',
    DESELECT_GROUP: 'relacionar-deselectGroup',
    CORRECT: 'relacionar-correct',
}